import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PasswordInput } from "@/components/ui/password-input";
import { Label } from "@/components/ui/label";
import { Lock } from "lucide-react";

export default function PasswordPromptDialog({ open, onOpenChange, title = "Senha de administrador", description, onConfirm }) {
  const [password, setPassword] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => { if (open) setPassword(""); }, [open]);

  const handle = async () => {
    if (!password.trim()) return;
    setSaving(true);
    try { await onConfirm?.(password); } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="password-prompt-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-[#1e3a8a]">
            <Lock className="w-5 h-5 text-amber-600" />
            {title}
          </DialogTitle>
        </DialogHeader>
        {description && <p className="text-xs text-slate-600">{description}</p>}
        <Label className="text-xs font-semibold uppercase tracking-wider text-slate-500">
          Senha
        </Label>
        <PasswordInput
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoFocus
          data-testid="password-prompt-input"
          onKeyDown={(e) => { if (e.key === "Enter" && password.trim()) handle(); }}
        />
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button
            onClick={handle}
            disabled={saving || !password.trim()}
            className="bg-[#7c3aed] hover:bg-[#6d28d9] text-white"
            data-testid="password-prompt-confirm"
          >
            {saving ? "Validando..." : "Confirmar"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
